export interface ChronologyNode {
    date: string;
    title: string;
    body: string;
    list?: Array<string>;
    projects?: Array<{
        title: string;
        name: string;
        body: string;
        lead?: string;
    }>;
    badges?: Array<string>;
}

export const CHRONOLOGY_NODES: Array<ChronologyNode> = [
    {
        date: "2025.03 - 2025.08",
        title: "Programmers 데브코스 웹프론트엔드 4기",
        body: "HTML, CSS, JavaScript 기초부터 TypeScript, React, Vue, Next.js 심화까지 학습",
        list: [
            "라우팅, Zustand를 활용한 전역 상태 관리, API 연동, Vite를 활용한 프로젝트 빌드 등의 사용 경험",
            "같은 직군부터 다른 직군까지와의 팀프로젝트 경험",
            "기획부터 개발, 배포까지의 전체 프로세스 경험",
        ],
        projects: [
            {
                title: "TEAM PROJECT 1",
                name: "Devtion",
                body: "Notion 클론 코딩",
            },
            {
                title: "TEAM PROJECT 2",
                name: "De:caffeine",
                body: "개발자를 위한 커뮤니티",
            },
            {
                title: "TEAM PROJECT 3",
                name: "북적북적",
                body: "독서를 기록하고, 공유하는 독서 커뮤니티",
            },
            {
                title: "TEAM PROJECT 4",
                name: "Studium",
                body: "목표 기반 스터디 관리 웹앱",
                lead: "FrontEnd",
            },
        ],
        badges: ["React", "Next.js", "Vue.js", "Team Project", "Code Review"],
    },
    {
        date: "2021.03 - 2025.08",
        title: "인천대학교 컴퓨터공학부",
        body: "인천대학교 컴퓨터공학부 학사 졸업",
        list: [
            "Python, C, C++, C#, Java, JSP, Kotlin, R 등 프로그래밍 언어 기초 학습",
            "자료구조, 데이터베이스, 알고리즘, 웹프로그래밍 등 핵심 전공 과목 이수",
        ],
        projects: [
            {
                title: "GRADUATION PROJECT",
                name: "INUsed",
                body: "교내 중고거래 서비스",
            },
        ],
        badges: ["React", "Team Project", "Code Review"],
    },
    {
        date: "2021.03 - 2024.12",
        title: "인천대학교 단과대학 & 학과 학생회",
        body: `단과대학 학생회 및 컴퓨터공학부 21학번 과대표 활동`,
        list: [
            "단과대학 행사 기획, 홍보, 현장 운영 등 전 과정에 참여하며 원활한 행사 진행에 기여",
            "기획부장으로서 행사 홍보물 및 소품 제작",
            "과대표로 활동하며 구성원 간의 단합과 협력 강화 도모",
        ],
    },
    {
        date: "2024.06",
        title: "2024 실리콘밸리 SW개발 아이디어 해커톤",
        body: `실리콘밸리 엔지니어 + 테커가 함께하는 무박 2일 해커톤 참가`,
        list: [
            "제한된 시간 안에 아이디어를 구체화하고 결과물을 도출하는 과정 경험",
        ],
        projects: [
            {
                title: "TEAM PROJECT",
                name: "Filly",
                body: "감정을 담은, 다같이 만드는 플레이리스트",
            },
        ],
        badges: ["ChatGPT API", "HTML5 / JavaScript", "Team Project"],
    },
    {
        date: "2021.04 - 2022.06",
        title: "Internet Software Lab",
        body: "인천대학교 컴퓨터공학부 Internet Software Lab에서 학부연구생 활동",
        list: [
            "HTML 기반 웹 기술 학습을 통해 웹 구조 및 동작 원리에 대한 이해도 향상",
            "Machine Learning 기초 이론을 학습하며 데이터 기반 문제 해결 방식에 대한 이해도 향상",
        ],
    },
    {
        date: "2021.06 - 2021.07",
        title: `가짜개발자 Season 3`,
        body: `인천대학교 깃허브/알고리즘 스터디 "가짜개발자" 활동`,
        list: [
            "백준 알고리즘 문제 풀이 및 코드 설명을 통해 알고리즘 역량 향상",
            "GitHub의 기본 사용법을 학습하고 코드 관리 및 공유를 경험하며 이해도 향상",
        ],
    },
];
